import React, { memo } from 'react';
import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { AppBreadcrumb } from './AppBreadcrumb';
import { BreadcrumbProvider, type BreadcrumbItem } from '@/shared/lib/breadcrumb-context';
import { layoutStyles } from '@/shared/styles/layoutStyles';

const { Content } = Layout;

interface MainContentProps {
  collapsed: boolean;
  width: number;
  collapsedWidth: number;
  customBreadcrumbs: BreadcrumbItem[] | null;
  setCustomBreadcrumbs: (items: BreadcrumbItem[] | null) => void;
  hideHeader?: boolean;
  isMobile?: boolean;
}

export const MainContent: React.FC<MainContentProps> = memo(({
  collapsed,
  width,
  collapsedWidth,
  customBreadcrumbs,
  setCustomBreadcrumbs,
  hideHeader = false,
  isMobile = false
}) => {
  const location = useLocation();
  // On mobile, no margin needed since sidebar is hidden
  const marginLeft = isMobile ? 0 : (collapsed ? collapsedWidth : width);

  return (
    <Layout style={{ marginLeft, transition: 'margin-left 0.2s' }}>
      <Content style={layoutStyles.content}>
        <div style={layoutStyles.contentPadding}>
          {!hideHeader && <AppBreadcrumb customBreadcrumbs={customBreadcrumbs} />}
          
          <BreadcrumbProvider value={{ items: customBreadcrumbs, setItems: setCustomBreadcrumbs }}>
            {location.pathname === '/demo' || location.pathname === '/' ? (
              <div style={layoutStyles.demoContainer}>
                <Outlet />
              </div>
            ) : (
              <div style={layoutStyles.pageContainer}>
                <Outlet />
              </div>
            )}
          </BreadcrumbProvider>
        </div>
      </Content>
    </Layout>
  );
});

MainContent.displayName = 'MainContent';